export default __webpack_public_path__ + "static/media/037-suitcase.65448683.svg";